import { render, staticRenderFns } from "./coste_adicional.vue?vue&type=template&id=0ce4f047&"
import script from "./coste_adicional.vue?vue&type=script&lang=js&"
export * from "./coste_adicional.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports